module.exports = __webpack_public_path__ + "static/media/IconTemplates_-15.9124cbd8.svg";